<template>
	<div class="news">
		<div class="news-box">
			<div class="title">
				<img src="@/assets/images/title_2.png"/>
			</div>
			<div class="tab">
				<div v-for="item in tabs" class="item" :class="{ 'active': tabActive === item.dictValue }"
					@click="changeType(item.dictValue)">
					<span>{{ item.dictLabel }}</span>
				</div>
			</div>
			<div class="list">
				<div class="item" v-for="(item, index) in news" @click="goDetail(item, index)">
					<img :src="item.pic" style="object-fit: cover;">
					<h3>{{ item.title }}</h3>
					<div class="info">
						<span class="time">{{ item.pushDate }}</span>
						<span class="form">{{ item.mediaChannel }}</span>
					</div>
					<div class="des">{{ item.excerpt }}</div>
				</div>
			</div>

			<div class="pages">
				<Page :page-index="pageNum" :total="total" :page-size="12" @change="pageChange"></Page>
			</div>
		</div>
	</div>
</template>

<script>
import { queryListFromH5, getNewsTab } from '@/axios/api.js'
import Page from '@/components/Page.vue'
export default {
	data() {
		return {
			tabs: [],
			tabActive: '',
			news: [],
			pageNum: 1,
			total: 0,
		}
	},
	created() {
		getNewsTab().then(res => {
			this.tabs = res.data.data
			this.tabActive = this.tabs[0].dictValue

			this.getNews()
		})
	},
	mounted() {

	},
	computed: {},
	watch: {},
	methods: {
		getNews() {
			this.news = []
			let params = {
				pageNum: this.pageNum,
				pageSize: 12,
				tab: this.tabActive,
			}
			queryListFromH5(params).then(res => {
				this.news = res.data.data.list
				this.total = res.data.data.total
			})
		},
		changeType(dictValue) {
			this.tabActive = dictValue
			this.getNews()
		},

		pageChange(page) {
			this.pageNum = page
			this.getNews()
		},

		goDetail(item, index) {
			if(item.jumpType === '外部链接'){
				window.open(item.outLink)
			}else{
				this.$router.push(`/detail?id=${item.id}&tab=${this.tabActive}&nodeNum=${index + 1}`)
			}
		},
	},
	beforeDestroy() {

	},
	components: {
		Page
	}
}
</script>

<style scoped lang="less">
.pages {
	display: flex;
	justify-content: center;
}

.news-box {
	padding: 120px 0 60px 0;
	background: #fff url('../../assets/images/news_bg.png') top center no-repeat;
	background-size: cover;
	box-sizing: border-box;
	min-height: calc(100vh - 57px);

	.title {
		margin-bottom: 40px;
		img{
			display: block;
			margin: 0 auto;
			width: auto;
			height: 84px;
		}
	}

	.tab {
		width: 1180px;
		margin: 0 auto 28px auto;
		display: flex;
		align-items: center;
		
		.item {
			margin-right: 20px;
			border-radius: 66px;
			display: flex;
			align-items: center;
			cursor: pointer;
			background: #fff;
			height: 66px;
			padding: 0 40px;
	
		
			span {
				color: #FF4F6A;
				font-size: 26px;
				font-weight: 500;
			}
		
			&.active {
				background: #FF4F6A;
				span {
					color: #fff;
				}
			}
		}
	}

	.list {
		width: 1196px;
		margin: 0 auto 50px auto;
		display: flex;
		flex-wrap: wrap;

		.item {
			width: 382px;
			height: 370px;
			padding: 16px;
			box-sizing: border-box;
			background: #fff;
			margin: 0 8px 40px 8px;
			cursor: pointer;

			img {
				width: 100%;
				height: 148px;
			}

			h3 {
				margin-bottom: 12px;
				font-size: 18px;
			}

			.info {
				margin-bottom: 12px;

				span {
					font-size: 12px;

					&.time {
						color: #AEB3C0;
						margin-right: 16px
					}
				}
			}

			.des {
				color: #AEB3C0;
				font-size: 15px;
			}
		}
	}
}
</style>